import { GithubOutlined, LinkedinOutlined } from '@ant-design/icons'
import { Form, FormInstance, Input, Select, Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Address, Cities, Floors } from '@/shares/i18n-mapping'

export interface UserInfoEditModalFormProps {
  location: string
  address: string
  floor: string
  seatNumber: string
  aboutMe: string
  linkedin: string
  github: string
}

export const UserInfoEditModalForm: React.FC<{ form: FormInstance; initialValues: UserInfoEditModalFormProps }> = ({
  form,
  initialValues: formInitialValues,
}) => {
  const { t } = useTranslation()

  const [location, setLocation] = React.useState<string>('')
  const [address, setAddress] = React.useState<string>('')

  React.useEffect(() => {
    form.setFieldsValue(formInitialValues)
    setLocation(formInitialValues.location)
    setAddress(formInitialValues.address)
  }, [formInitialValues])

  return (
    <Form
      form={form}
      labelCol={{ span: 4 }}
      preserve={false}
      onValuesChange={(changedValues) => {
        if (changedValues.location) {
          const location = changedValues.location
          const address = Object.entries(Address[location])[0][0]
          const floor = Object.entries(Floors[address])[0][0]
          setLocation(location)
          setAddress(address)
          form.setFieldsValue({ address, floor })
        }

        if (changedValues.address) {
          const address = changedValues.address
          const floor = Object.entries(Floors[address])[0][0]
          setAddress(address)
          form.setFieldsValue({ floor })
        }
      }}
    >
      <Typography.Title level={5}>{t('user.info.about')}</Typography.Title>
      <Form.Item label={t('user.info.modal.city')} name='location' required>
        <Select
          options={Object.entries(Cities).map(([key, val]) => ({
            label: t(val),
            value: key,
          }))}
        />
      </Form.Item>
      <Form.Item label={t('user.info.modal.address')} name='address'>
        <Select
          options={Object.entries(Address[location] || {}).map(([key, val]: any) => ({
            label: val,
            value: key,
          }))}
        />
      </Form.Item>
      <Form.Item label={t('user.info.modal.floor')} name='floor'>
        <Select
          options={Object.entries(Floors[address] || {}).map(([key, val]: any) => ({
            label: val,
            value: key,
          }))}
        />
      </Form.Item>
      <Form.Item label={t('profile.basic.seatNumber')} name='seatNumber'>
        <Input />
      </Form.Item>
      <Form.Item label={t('profile.basic.aboutMe')} name='aboutMe'>
        <Input.TextArea showCount maxLength={100} autoSize={{ minRows: 6, maxRows: 6 }} />
      </Form.Item>
      <Typography.Title level={5}>{t('user.info.website')}</Typography.Title>
      <Form.Item
        label={
          <div>
            <LinkedinOutlined /> <span>{t('user.info.linkedin')}</span>
          </div>
        }
        name='linkedin'
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={
          <div>
            <GithubOutlined /> <span>{t('user.info.github')}</span>
          </div>
        }
        name='github'
      >
        <Input />
      </Form.Item>
    </Form>
  )
}
